import React, { useEffect, useState } from "react";
import classes from "./TopSummary.module.scss";
import Header from "../../molecules/header/Header";
import { getSyntheticLeadingComments } from "typescript";
import { useNavigate } from "react-router-dom";
import pointTitleImage from "../../static/images/point-title.png";

type Props = {
  leftLogo?: string;
  rightLogo?: string;
  subTitle?: string;
  mainTitle: string;
  color?: "orange" | null;

};

const TopSummary = (props: Props) => {
  const { color } = props;
  const containerClass =
    color === "orange"
      ? `${classes.container} ${classes.orange}`
      : classes.container;

  return (
    <>
      <div className={containerClass}>
        <div className={classes.leftLogo}>
          <img src={props.leftLogo} alt={props.leftLogo} />
        </div>
        <div className={classes.title}>
          {props.subTitle != null && (
            <div className={classes.subTitle}>{props.subTitle}</div>
          )}
          <div className={classes.mainTitle}>{props.mainTitle}</div>
        </div>
        <div className={classes.rightLogo}>
          <img src={props.rightLogo} alt={props.rightLogo} />
        </div>
      </div>
    </>
  );
};

export default TopSummary;
